<template>
  <v-app>
    <vue-progress-bar></vue-progress-bar>
    <transition name="fade" mode="out-in">
      <router-view />
    </transition>
  </v-app>
</template>

<script>
export default {
  name: 'App',
  onIdle() {
    if (this.$store.getters.GET_TOKEN.length !== 0) {
        this.$store.dispatch('SIGN_OUT_USER')
    }
  },
};
</script>

<style lang="scss">
:root {
  --main-kenes-blue: black;

//  #FA4A0C;
//#f26b33;
}
body {
  overflow-x: hidden;
  letter-spacing: -0.03em;
  background-color: white !important;
  font-weight: 400;
  line-height: 1.5;
}


@font-face {
  font-family: "MontserratRegular";
  src: url("./fonts/Montserrat-Regular.eot");
  src: local("Montserrat Regular"), local("Montserrat-Regular"),
  url("./fonts/Montserrat-Regular.eot?#iefix") format("embedded-opentype"),
  url("./fonts/Montserrat-Regular.woff") format("woff"),
  url("./fonts/Montserrat-Regular.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}


@font-face {
  font-family: 'Chalk';
  src: url('./fonts/KGBrokenVesselsSketch.ttf');
  font-weight: 800;
  font-style: normal;
}

@font-face {
  font-family: "MontserratRegular";
  src: url("./fonts/Montserrat-Regular.eot");
  src: local("Montserrat Regular"), local("Montserrat-Regular"),
    url("./fonts/Montserrat-Regular.eot?#iefix") format("embedded-opentype"),
    url("./fonts/Montserrat-Regular.woff") format("woff"),
    url("./fonts/Montserrat-Regular.ttf") format("truetype");
  font-weight: normal;
  font-style: normal;
}
@font-face {
  font-family: "MontserratBold";
  src: url("./fonts/Montserrat-Bold.eot");
  src: local("Montserrat Bold"), local("Montserrat-Bold"),
    url("./fonts/Montserrat-Bold.eot?#iefix") format("embedded-opentype"),
    url("./fonts/Montserrat-Bold.woff") format("woff"),
    url("./fonts/Montserrat-Bold.ttf") format("truetype");
  font-weight: bold;
  font-style: normal;
}
@font-face {
  font-family: "MontserratLight";
  src: url("./fonts/Montserrat-Light.eot");
  src: local("Montserrat Light"), local("Montserrat-Light"),
    url("./fonts/Montserrat-Light.eot?#iefix") format("embedded-opentype"),
    url("./fonts/Montserrat-Light.woff") format("woff"),
    url("./fonts/Montserrat-Light.ttf") format("truetype");
  font-weight: 300;
  font-style: normal;
}
@font-face {
  font-family: "MontserratItalic";
  src: url("./fonts/Montserrat-Italic.eot");
  src: local("Montserrat Italic"), local("Montserrat-Italic"),
    url("./fonts/Montserrat-Italic.eot?#iefix") format("embedded-opentype"),
    url("./fonts/Montserrat-Italic.woff") format("woff"),
    url("./fonts/Montserrat-Italic.ttf") format("truetype");
  font-weight: normal;
  font-style: italic;
}
@font-face {
  font-family: "MontserratSemiBold";
  src: url("./fonts/Montserrat-SemiBold.eot");
  src: local("Montserrat SemiBold"), local("Montserrat-SemiBold"),
    url("./fonts/Montserrat-SemiBold.eot?#iefix") format("embedded-opentype"),
    url("./fonts/Montserrat-SemiBold.woff") format("woff"),
    url("./fonts/Montserrat-SemiBold.ttf") format("truetype");
  font-weight: 600;
  font-style: normal;
}
@font-face {
  font-family: "MontserratExtraBold";
  src: url("./fonts/Montserrat-ExtraBold.eot");
  src: url("./fonts/Montserrat-ExtraBold.eot?#iefix")
      format("embedded-opentype"),
    url("./fonts/Montserrat-ExtraBold.woff") format("woff"),
    url("./fonts/Montserrat-ExtraBold.ttf") format("truetype");
  font-weight: 800;
  font-style: normal;
}
p,a,input,.v-select__selections,v-text-field__slot,label {
  font-family: "MontserratRegular" !important;
}

.v-notices .v-toast .v-toast-text {
    font-family: "MontserratBold";
}
.item__family {
  font-family: "MontserratRegular";
}
.item__btn { 
  background: linear-gradient(48deg, rgba(131,58,180,1) 10%, rgba(253,29,29,1) 60% 100%);
}
.item__fe {
    justify-content: flex-end;
}
.item__pointer {
  cursor: pointer;
}
.item__90 {
  width: 90%;
}
.item__as {
  align-self: center;
}

.item__mb {
  margin-bottom: 20px;
}
.item__mt {
  margin-top: 15px;
}

.item__wrap {
  display: flex;
  flex-wrap: wrap;
}
.item__row {
  display: flex;
  flex-direction: row;
}
.item__column {
  display: flex;
  flex-direction: column;
}
.item__ac {
  align-items: center;
}
.item__jb {
  justify-content: space-between;
}
.item__100 {
  width: 100%;
}
.item__abs {
  display: flex;
  justify-content: center;
  align-items: center;
}
.item__c {
  justify-content: center;
}
  .button {   
                font-weight: bold;
                text-align:center;
                width: 100%;
                outline: none;
                border:none;
                background-image: linear-gradient(to right, #2a2e36, #38323c, #46363d, #503c3a, #544437);
                color: white;
                padding: 20px;
                border-radius: 20px;
                box-shadow: rgba(0, 0, 0, 0.25) 0px 54px 55px, rgba(0, 0, 0, 0.12) 0px -12px 30px, rgba(0, 0, 0, 0.12) 0px 4px 6px, rgba(0, 0, 0, 0.17) 0px 12px 13px, rgba(0, 0, 0, 0.09) 0px -3px 5px;
                @media (max-width: 900) {
                    width: 100%;
                    
                }

            }

            button:hover {
              opacity: 0.9;
            }
</style>
